<template>
  <div>
    <a-spin :spinning="spinning" tip="Loading...">
      <vxe-toolbar>
        <template #buttons>
          <vxe-input
            v-model="filterName_detable"
            type="search"
            placeholder="Input gene"
          ></vxe-input>
          <vxe-button @click="exportDataEvent"
            ><a-icon type="cloud-download" /> Download</vxe-button
          >
        </template>
      </vxe-toolbar>
      <vxe-table
        border
        show-overflow
        row-id="id"
        size="small"
        ref="xTable"
        :data="tableData_detable"
        align="center"
        header-align="center"
        class="my-sort"
        :row-config="{ isHover: true, isCurrent: true, isHover: true }"
        :sort-config="{
          showIcon: false,
          trigger: all,
        }"
        @header-cell-click="headerCellClickEvent"
      >
        <vxe-column
          field="diffgene"
          title="Gene"
          width="150px"
          type="html"
          :titlePrefix="{
            icon: 'vxe-icon-question-circle-fill',
            useHTML: true,
            message: 'The gene you recently searched for',
          }"
        >
          <template #default="{ row }">
            <a @click="goPerturbgene_detable(row.diffgene)">{{
              row.diffgene
            }}</a>
          </template>
        </vxe-column>
        <vxe-column
          field="perturbgene"
          title="Perturbed gene"
          :titlePrefix="{
            icon: 'vxe-icon-question-circle-fill',
            useHTML: true,
            message:
              'Perturbation of the genes have significant effects on the target gene expression levels',
          }"
          type="html"
        ></vxe-column>
        <vxe-column field="fc" title="Avg_log2FC" sortable type="html">
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span> </template
        ></vxe-column>
        <vxe-column
          field="pvalue"
          title="P-value"
          sortable
          :titlePrefix="{
            icon: 'vxe-icon-question-circle-fill',
            useHTML: true,
            message:
              'P-value not adjusted for multiple test correction for condition',
          }"
          type="html"
        >
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span> </template
        ></vxe-column>
        <vxe-column
          field="padj"
          title="P_val_adj"
          :titlePrefix="{
            icon: 'vxe-icon-question-circle-fill',
            useHTML: true,
            message:
              'Adjusted p-value for condition, based on bonferroni correction, used to determine significance',
          }"
          sortable
          type="html"
        >
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span> </template
        ></vxe-column>

        <vxe-column
          field="pct1"
          :titlePrefix="{
            icon: 'vxe-icon-question-circle-fill',
            useHTML: true,
            message:
              'The percentage of cells in the treatment group where the gene is detected',
          }"
          title="Pct.1"
          type="html"
        ></vxe-column>
        <vxe-column
          field="pct2"
          title="Pct.2"
          :titlePrefix="{
            icon: 'vxe-icon-question-circle-fill',
            useHTML: true,
            message:
              'The percentage of cells in the NT group where the gene is detected',
          }"
          type="html"
        ></vxe-column>

        <template #empty>
          <span style="color: grey">
            No records found. Please enter a valid gene to browse.
          </span>
        </template>
      </vxe-table>

      <vxe-pager
        background
        size="small"
        :loading="loading_detable"
        :current-page="tablePage_detable.currentPage"
        :page-size="tablePage_detable.pageSize"
        :total="tablePage_detable.totalResult"
        :page-sizes="[10, 20, 50, 100]"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          // 'FullJump',
          'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange_table"
      >
      </vxe-pager>
    </a-spin>
  </div>
</template>
<script>
import axios from "axios";
import XEUtils from "xe-utils";
// import downloadexcel from "vue-json-excel";

export default {
  // components: { downloadexcel },
  props: ["choosepathway"],
  data() {
    return {
      //加载
      spinning: false,
      //全表搜索\
      defaultGene: {
        SC00001: "IRF1",
        SC00002: "DCAF13",
        SC00003: "DCAF13",
        SC00004: "DCAF13",
        SC00005: "RPL9",
        SC00006: "MAPK1",
        SC00007: "ATF6",
        SC00008: "SPI1",
        SC00009: "AARS",
        SC00010: "IFNGR1",
        SC00011: "IFNGR1",
        SC00012: "IFNGR1",
        SC00013: "RPL37A",
        SC00014: "MTOR",
        SC00015: "IFNAR1",
        SC00016: "MTOR",
        SC00017: "DCAF13",
        SC00018: "MTOR",
        SC00019: "PTEN",
        SC00020: "TP53",
        SC00021: "TP53",
        SC00022: "SMARC",
        SC00023: "SMARC",
        SC00024: "SMARC",
        SC00025: "SMARC",
        SC00026: "SMARC",
        SC00027: "SMARC",
        SC00028: "SMARC",
        SC00029: "SMARC",
        SC00030: "SMARC",
        SC00031: "SMARC",
        SC00032: "SMARC",
        SC00033: "SMARC",
        SC00034: "SMARC",
        SC00035: "SMARC",
        SC00036: "SMARC",
        SC00037: "AGO2",
        SC00038: "CD274",
        SC00039: "CD274",
        SC00040: "MTOR",
        SC00041: "EIF2B",
        SC00042: "MTOR",
        SC00043: "MTOR",
        SC00044: "MTOR",
        SC00045: "MTOR",
        SC00046: "MTOR",
        SC00048: "MCM",
        SC00049: "MTOR",
        SC00050: "MTOR",
        SC00051: "MTOR",
        SC00052: "MTOR",
        SC00053: "MTOR",
        SC00054: "MTOR",
        SC00055: "MTOR",
        SC00056: "TGFBR2",
        SC00057: "TGFBR2",
        SC00058: "MTOR",
        SC00059: "MTOR",
        SC00060: "MTOR",
        SC00061: "MTOR",
        SC00062: "MT-CO1",
        SC00063: "MCM3",
        SC00064: "STAT3",
        SC00065: "LAMTOR1",
        SC00066: "LAMTOR1",
      },
      filterName_detable: "",
      tempdata_detable: [],
      //排序用来记录原始数据的向量：
      orginData: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: false,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
    };
  },
  watch: {
    filterName_detable() {
      console.log(this.filterName_detable);
      this.tablePage_detable.currentPage = 1;
      if (this.filterName_detable != "") {
        axios
          .get(
            "http://research.gzsys.org.cn/perturbdb/API/publications_deTable.php",
            {
              params: {
                datasetId: this.$route.query.datasetId,
                gene: this.filterName_detable,
              },
            }
          )
          .then((response) => {
            this.getdata_detable = response.data;
            this.orginData = response.data;
            this.findList_detable(this.getdata_detable);
            this.spinning = false;
          });
      } else {
        axios
          .get(
            "http://research.gzsys.org.cn/perturbdb/API/publications_deTable.php",
            {
              params: {
                datasetId: this.$route.query.datasetId,
                gene: " ",
              },
            }
          )
          .then((response) => {
            this.getdata_detable = response.data;
            this.orginData = response.data;
            this.findList_detable(this.getdata_detable);
            this.spinning = false;
          });
      }
    },
  },
  created() {
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/publications_deTable.php",
        {
          params: {
            datasetId: this.$route.query.datasetId,
            gene: this.defaultGene[this.$route.query.datasetId],
          },
        }
      )
      .then((response) => {
        this.filterName_detable = this.defaultGene[this.$route.query.datasetId];
        this.getdata_detable = response.data;
        this.orginData = response.data;
        this.findList_detable(this.getdata_detable);
        this.spinning = false;
      });
  },

  methods: {
    headerCellClickEvent({
      column,
      triggerResizable,
      triggerSort,
      triggerFilter,
    }) {
      // 如果触发了列的其他功能按钮
      console.log(column["field"]);
      if (
        column.sortable &&
        !(triggerResizable || triggerSort || triggerFilter)
      ) {
        if (column.order === "desc") {
          this.$refs.xTable.clearSort();
          this.findList_detable(this.orginData);
        } else if (column.order === "asc") {
          this.$refs.xTable.sort(column.property, "desc");
          var jiangxu = this.getdata_detable.sort(
            (a, b) => b[column.field] - a[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = jiangxu;
          this.findList_detable(this.getdata_detable);
        } else {
          this.$refs.xTable.sort(column.property, "asc");
          var shengxu = this.getdata_detable.sort(
            (a, b) => a[column.field] - b[column.field]
          ); // 按照 num 属升序排序
          this.getdata_detable = shengxu;
          this.findList_detable(this.getdata_detable);
        }
      }
    },
    formatAmount({ cellValue }) {
      return XEUtils.commafy(XEUtils.toNumber(cellValue));
    },
    exportDataEvent() {
      if (this.tempdata_detable.length == 0) {
        const list = this.getdata_detable;
        this.$refs.xTable.exportData({
          filename: this.$route.query.datasetId + "_all_DE_gene",
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        const list = this.tempdata_detable;
        this.$refs.xTable.exportData({
          filename: this.filterName_detable + "_related",
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      }
    },
    goPerturbgene_detable(value) {
      let href =
        "https://www.genecards.org/cgi-bin/carddisp.pl?gene=" +
        value +
        "&keywords=" +
        value;
      window.open(href, "_blank");
    },
    findList_detable(data) {
      this.loading_detable = true;
      setTimeout(() => {
        const list = data;
        this.loading_detable = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    // searchEvent_detable() {
    //   const filterName = XEUtils.toValueString(this.filterName_detable)
    //     .trim()
    //     .toLowerCase();
    //   if (filterName) {
    //     const filterRE = new RegExp(filterName, "gi");
    //     const searchProps = ["diffgene", "perturbgene"];
    //     const rest = this.getdata_detable.filter((item) =>
    //       searchProps.some(
    //         (key) =>
    //           XEUtils.toValueString(item[key])
    //             .toLowerCase()
    //             .indexOf(filterName) > -1
    //       )
    //     );
    //     this.tempdata_detable = rest.map((row) => {
    //       const item = Object.assign({}, row);
    //       searchProps.forEach((key) => {
    //         item[key] = XEUtils.toValueString(item[key]).replace(
    //           filterRE,
    //           (match) => `${match}`
    //         );
    //       });
    //       return item;
    //     });
    //     this.findList_detable(this.tempdata_detable);
    //   } else {
    //     this.findList_detable(this.getdata_detable);
    //   }
    // },
  },
};
</script>
<style scpoed>
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}
.my-sort .custom-sort {
  padding: 0 4px;
}
.my-sort .custom-sort.is-order {
  color: #409eff;
}
</style>
